import React from 'react';

import DetailsDrawer from "./Components/DetailsDrawer";

import Thanks from './Components/advertise/Thanks'
import Resume from './Components/advertise/coupon/Resume'
import PricePlanAffiliate from './Pages/PricePlanAffiliate.jsx';
import PricePlan from './Pages/PricePlan.jsx';
import PaymentSuccess from './Components/PaymentSuccess.jsx';
import PaymentError from './Components/PaymentError.jsx';
import RenewPopin from './Pages/RenewPopin.jsx';


import { BrowserRouter, Routes, Route, NavLink } from "react-router-dom";

import { DrawerContextProvider } from './store/DrawerContext.js';
// OLD CODE - Commented out for migration cleanup
// import { DataContextProvider } from './store/DataContext.js';
import { WizardDataProvider } from './store/WizardDataContext.js';
import HelpWithCoupons from './Pages/HelpWithCoupons.jsx';
import HelpMe from './Pages/HelpMe.jsx';
// OLD CODE - Commented out for migration cleanup
// import CreateCoupon from './Pages/CreateCoupon.jsx';
import WizardContainer from './Pages/WizardContainer.jsx';
import { PricePlanProvider } from './store/PricePlanContext.js';

function App() {


  return (
    <div className="App">

      <DrawerContextProvider>
        {/* OLD CODE - Commented out for migration cleanup */}
        {/* <DataContextProvider> */}
          <WizardDataProvider>
            <PricePlanProvider>
              <BrowserRouter>
                <Routes>
                  <Route path="/:affiliateCode" exact element={<PricePlanAffiliate />} />
                  <Route path="/" exact element={<PricePlan />} />
                  <Route path="/price-plan" exact element={<PricePlan />} />
                  <Route path="/advertise/:term/help" exact element={<HelpWithCoupons />} />
                  <Route path="/advertise/:term/help-me" exact element={<HelpMe />} />
                  <Route path="/advertise/coupon/:term/create-coupon/:id" exact element={<WizardContainer />} />
                  <Route path="/advertise/coupon/resume" exact element={<Resume />} />
                  <Route path="/advertise/thanks" exact element={<Thanks />} />
                  <Route path="/payment/success" exact element={<PaymentSuccess />} />
                  <Route path="/payment/cancel" exact element={<PaymentError />} />
                  <Route path="/renew/:popinId" exact element={<RenewPopin />} />
                </Routes>
                <DetailsDrawer />
              </BrowserRouter>
            </PricePlanProvider>
          </WizardDataProvider>
        {/* OLD CODE - Commented out for migration cleanup */}
        {/* </DataContextProvider> */}
      </DrawerContextProvider>

    </div>
  );
}

export default App;
